import { FormField } from "#components/ui/FormField.tsx";
import { FormFieldLabel } from "#components/ui/FormFieldLabel.tsx";
import { PersonalityPresets } from "#features/personalization/components/PersonalityPresets.tsx";
import type { UpdatePersonalizationForm } from "#features/personalization/hooks/useUpdatePersonalizationForm.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Flex, Text, TextArea } from "@hopper-ui/components";
import { useFormContext } from "react-hook-form";

export const Personality = () => {
    const { tShared } = useSharedTranslation();
    const { control, getValues, setValue } = useFormContext<UpdatePersonalizationForm>();

    const handleSelect = (preset: string) => {
        const value = getValues("personality");

        // If the textarea has a value, append the preset to the existing value
        if (value.trim()) {
            setValue("personality", `${value} ${preset}`, { shouldDirty: true });

            return;
        }

        // If the textarea is empty, set the preset as the value
        setValue("personality", preset, { shouldDirty: true });
    };

    const examples = [
        tShared("personalization.tooltipExample1"),
        tShared("personalization.tooltipExample2"),
        tShared("personalization.tooltipExample3")
    ];

    return (
        <Flex direction="column" gap="inline-md">
            <FormFieldLabel
                tooltip={
                    <Flex direction="column" alignItems="start">
                        <Text size="sm" fontWeight="body-md-semibold" textAlign="left">{tShared("personalization.tooltipTitle")}</Text>
                        {examples.map(example => <Text key={example} size="sm" textAlign="left">{example}</Text>)}
                    </Flex>
                }
            >
                <Text fontWeight="body-md-medium">
                    {tShared("personalization.personalityLabel")}
                </Text>
            </FormFieldLabel>
            <FormField
                name="personality"
                control={control}
                render={({ field }) => (
                    <TextArea
                        {...field}
                        isFluid
                        aria-label={tShared("personalization.personalityLabel")}
                        placeholder={tShared("personalization.personalityPlaceholder")}
                        rows={4}
                    />
                )}
            />
            <PersonalityPresets onSelect={handleSelect} />
        </Flex>
    );
};
